import styled from 'styled-components'

export const Footer = styled.div`
  margin: 24px 0;
`
export const Checkout = styled.div`
  display: flex;
  margin-top: 40px;
  padding: 24px 24px 16px;
  border-top: 1px solid var(--gray200);

  h3 {
    font-family: 'Sora', 'Lato', sans-serif;
  }
`

export const Link = styled.span`
  color: var(--primary500);
  font-weight: 700;
`

export const AcceptTerns = styled.div`
  padding: 0 24px;
`
